export const EmptySvg = () => null
